export class ChangelogItem {
  id: number;
  version: string;
  publishDate: Date;
  status: string;
  category: string;
  content: string;
  enteredAt: Date;
  enteredBy: string;
  updatedAt: Date;
  updatedBy: string;
}
